module.exports = "/virtual-football-league/img/amblems/right/logos/FakeWolverhampton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/FakeWolverhampton.png
// module id = 2178
// module chunks = 4